import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { CarDetailsGeneralInfoComponent } from './car-details-general-info-component/car-details-general-info-component';
import { CarDetailsActivityComponent } from './car-details-activity-component/car-details-activity-component';
import { CarDetailsCommandsComponent } from './car-details-commands-component/car-details-commands-component';
import { CarDetailsNotes } from './car-details-notes/car-details-notes';
import { AddCarNoteForm } from '../../../../@shared/forms/vehicles/cars/add-car-note-form/add-car-note-form';
import { UpdateCarForm } from '../../../../@shared/forms/vehicles/cars/update-car-form/update-car-form';
import { Button } from 'primeng/button';
import { CarService } from '../../../../services/vehicles/car-service';
import { Car } from '../../../../models/car';
import { signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-car-details-component',
  imports: [CommonModule, TabsModule, Button, CarDetailsGeneralInfoComponent, CarDetailsActivityComponent, CarDetailsCommandsComponent, CarDetailsNotes, AddCarNoteForm, UpdateCarForm],
  templateUrl: './car-details-component.html',
  styleUrl: './car-details-component.scss'
})
export class CarDetailsComponent implements OnInit {

  @ViewChild(CarDetailsGeneralInfoComponent) carDetailsGeneralInfoComponent: CarDetailsGeneralInfoComponent;
  @ViewChild(CarDetailsActivityComponent) carDetailsActivityComponent: CarDetailsActivityComponent;
  @ViewChild(CarDetailsNotes) carDetailsNotesComponent: CarDetailsNotes;

  carID: string
  activeTab = "0";
  car = signal<Car | undefined>(undefined);

  addCarNoteDialog = false;
  updateCarDialog = false;

  private activatedRoute = inject(ActivatedRoute)
  private router = inject(Router)
  private carService = inject(CarService)

  ngOnInit() {
    this.getCarId()
    this.restoreTabFromUrl()
  }

  getCarId = () => {
    this.activatedRoute.paramMap.pipe(
      switchMap(params => {
        this.carID = params.get('id')!;
        return this.carService.getCarById(this.carID);
      })
    ).subscribe({
      next: (res) => this.car.set(res.data)
    });
  }

  restoreTabFromUrl = () => {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const tab = params.get('tab');
      this.activeTab = tab ?? '0';
    });
  }

  onTabChange = (tab: string | number | undefined) => {
    const tabValue = String(tab);
    this.activeTab = tabValue;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: tabValue },
      queryParamsHandling: ''
    }).then(() => {
      this.carDetailsActivityComponent?.resetAll(tabValue);
    });
  }

  goBack = () => {
    this.router.navigate(['/vehicles']);
  }

  openAddCarNoteForm = () => {
    this.addCarNoteDialog = true
  }

  onCarNoteAdded = () => {
    this.carDetailsNotesComponent?.getCarNotesList()
    this.addCarNoteDialog = false
  }

  onCarUpdated = () => {
    this.updateCarDialog = false;
    this.getCarId();
  }

  getStatusStyle(status?: string): { background: string; color: string } {
    const map: Record<string, { background: string; color: string }> = {
      'AVAILABLE':   { background: 'var(--status-available-bg)',   color: 'var(--status-available-text)' },
      'IN_USE':      { background: 'var(--status-in-use-bg)',       color: 'var(--status-in-use-text)' },
      'RESERVED':    { background: 'var(--status-reserved-bg)',     color: 'var(--status-reserved-text)' },
      'MAINTENANCE': { background: 'var(--status-maintenance-bg)',  color: 'var(--status-maintenance-text)' },
      'DISCHARGED':  { background: 'var(--status-discharged-bg)',   color: 'var(--status-discharged-text)' },
    };
    return map[status ?? ''] ?? { background: 'var(--status-reserved-bg)', color: 'var(--status-reserved-text)' };
  }
}
